module.exports = __webpack_public_path__ + "b71aaf46f6b67ffb72becc47d3348c28.pdf";